import * as React from 'react';
import { ReactNode } from 'react';
import '../css/buttons.sass';

interface StaticElementButtonProps {
  name: string;
  id: string;
  label: string;
  type: 'div' | 'span' | 'p';
  className?: string;
  children?: ReactNode;
  onClick?: Function;
  handleKeyDown?: Function;
  onBlur?: Function;
  disabled?: boolean;
  tabIndex?: number;
  isRoleButton?: boolean;
}

export default function StaticElementButton(props: StaticElementButtonProps) {
  const { tabIndex = 0, isRoleButton = true } = props;
  const handleKeyDown = (event: any) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault();
      if (props.onClick !== undefined && !props.disabled) {
        props.onClick(event);
      }
    } else if (props.handleKeyDown !== undefined) {
      props.handleKeyDown(event);
    }
  };

  return (
    <props.type
      role={isRoleButton ? 'button' : undefined}
      aria-label={isRoleButton ? props.label : undefined}
      id={props.id}
      tabIndex={props.disabled ? undefined : tabIndex}
      className={`staticElementButton ${props.className || ''}`}
      onMouseDown={(event) => {
        if (props.id !== 'clipboard') event.preventDefault();
      }}
      onClick={(e) => {
        if (props.onClick !== undefined && !props.disabled) {
          props.onClick(e);
        }
      }}
      onKeyDown={handleKeyDown}
      onBlur={(event) => props.onBlur !== undefined && props.onBlur(event)}
    >
      {props.children}
    </props.type>
  );
}
